/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class LicenseAgreementContent extends Component {}
